
<div>
    <div class="vertical-item">

        <div class=" col-lg-12 items  mb-1">
            <div class="col-md-3">
            <app-prix-public class=""></app-prix-public>
            </div>
            <div class="col-md-3">
            <app-tva-product class=""></app-tva-product>
            </div>
            <div class="col-md-3">
          <app-last-price-product class=""></app-last-price-product>
            </div>
            <div class="col-md-3">
         <app-valeur-stock class=""></app-valeur-stock>
            </div>


        </div>

        <div class="col-lg-12 items2">
            <div class="col-md-4">
                <app-product-info class=""></app-product-info>
            </div>

            <div class="col-md-4">
                <app-tarif class=""></app-tarif>
            </div>

            <div class="col-md-4">
                <app-logistic-info class=""></app-logistic-info>
            </div>
        </div>
    </div>
</div>
